import React from 'react';
import classNames from 'classnames';
import classes from './styles/index.module.scss';
import { getItemClasses } from './utils';
import List, { ListItem } from '../../../../components/List';
import { Typography } from '../../../../components/Typography';
import { gray, white } from '../../../../components/Color';
import { PROFILE_URL, useUserPageContextState } from '../../../user';
import { useStyleContextState } from '../../../styleContext';
import { ThemeStyle } from '../../../../utils/const';
import { closeActiveTooltip } from '../../../../components/TooltipBtn';
import { User } from '../../../../components/Icons/User';
import { syncManager } from '../../../../utils/syncManager';
import RouteLink from '../../../../components/RouteLink';

const HeaderUserActionsProfile = () => {
	const { theme } = useStyleContextState();
	const { email, formattedName } = useUserPageContextState();
	const componentClasses = classNames('metro-popup-caller', getItemClasses({ theme }));
	const userNameColor = theme === ThemeStyle.Dark ? white : gray[8];
	const iconColor = theme === ThemeStyle.Dark ? white : gray[7];

	const handleProfileLinkClick = () => {
		syncManager.emit('react', 'onNavigateToProfile');

		closeActiveTooltip();
	};

	return (
		<RouteLink
			className={componentClasses}
			href={PROFILE_URL}
			hasColor={false}
			noUnderline
			onClick={handleProfileLinkClick}
			useDirty
		>
			<User
				className={classes.buttonIcon}
				fill={iconColor}
			/>
			<List>
				<ListItem>
					<Typography
						fontSize='15px'
						color={userNameColor}
					>
						{formattedName}
					</Typography>
				</ListItem>
				<ListItem>
					<Typography
						color={gray[6]}
						fontSize='12px'
					>
						{email}
					</Typography>
				</ListItem>
			</List>
		</RouteLink>
	);
};

export default HeaderUserActionsProfile;
